import { Box, Container } from "@mui/material";
import CardServices from "../cardServices";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import RegisterAccess from '../../../utils/registerAccess';
// import { useSelector } from 'react-redux';

interface MenuState {
  analisado: number;
  deferido: number;
  reclamacoes: number;
  solicitacoesDesalfandegamento: number;
  declaracoesEmitidas: number;
  reprovado: number;
}
type MenuProps = {
  styles: string
}


export default function MenuDlifDesalfandegamento({ styles }: MenuProps) {
  // const user = useSelector(state => state.account.user);
  const [menu, setMenu] = useState<MenuState>({
    analisado: 0,
    deferido: 0,
    reclamacoes: 0,
    solicitacoesDesalfandegamento: 0,
    declaracoesEmitidas: 0,
    reprovado: 0,
  })
  const [loadMenu, setLoadMenu] = useState<boolean>(true)

  useEffect(() => {
    api.get(`/menu/dlif`)
      .then(response => {
        setMenu(response.data);
      }).catch(error => {

      }).finally(() => setLoadMenu(false))

  }, [])

  return (
    <Container>
      <RegisterAccess page={'menu desalfandegamento'} />

      <Box className={styles}>
        <CardServices funcao='Técnico' load={loadMenu} count={menu.solicitacoesDesalfandegamento} icone={'/icones/Desalfandegar.svg'} nomeService={'Solicitaçōes de Desalfandegamento '} link={'/admin/dmts/solicitacoes-de-desalfandegamento/produtos/Análise'} />
        <CardServices funcao='Técnico' load={loadMenu} count={menu.reprovado} icone={'/icones/solictacoesReprovadas.svg'} nomeService={'Solicitaçōes de Reprovadas '} link={'/admin/dmts/solicitacoes-de-desalfandegamento/produtos/Reprovado'} />
        {/* <CardServices load={loadMenu} count={menu.reclamacoes} icone={'/icones/Reclamacoes.svg'} nomeService={'Reclamações'} link={'/admin/reclamacoes?page=1'} /> */}
      </Box>

      <Box className={styles}>
        <CardServices load={loadMenu} count={menu.analisado} icone={'/icones/chefedaSeccao.svg'} nomeService={'Directora Adjunta área técnica'} link={'/admin/dmts/solicitacoes-de-desalfandegamento/produtos/Analisado'} />
        <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.deferido} icone={'/icones/chefeDepartamento.svg'} nomeService={'Chefe de Departamento'} link={'/admin/dmts/solicitacoes-de-desalfandegamento/produtos/Deferimento'} />
        <CardServices funcao='' load={loadMenu} count={menu.declaracoesEmitidas} icone={'/icones/controleQualidade/certificadosAutorizacoes.svg'} nomeService={'Declarações Emitidas'} link={'/admin/dmts/solicitacoes-de-desalfandegamento/produtos/Aprovado'} />
      </Box>
    </Container>
  )
}





